/*global google:false */
/*global PhotoSwipe:false */
/*global PhotoSwipeUI_Default:false */

window.bpLarge = 1280;
window.bpIPadMax = 1024;
window.bpMedium = 960;
window.bpIPadMin = 768;
window.bpSmall = 640;
window.bsLGB = 992;

/**
 * breakpoints
 */
window.width = $(window).width();
window.windowInnerWidth = window.innerWidth || $(window).width();
window.windowInnerHeight = window.innerHeight || $(window).height();

if (window.width !== window.windowInnerWidth) {
    window.scrollBar = true;
} else {
    window.scrollBar = false;
}

var arrowLeft = '<svg viewBox="0 0 90 90" width="90" height="90" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"><g><path d="M45 89.8A44.9 44.9 0 1 1 45 0a44.9 44.9 0 0 1 0 89.8zm0-86.6a41.8 41.8 0 1 0 0 83.7 41.8 41.8 0 0 0 0-83.7z"/><path d="M50.1 60.7c-.3 0-.7-.1-1-.4L34.2 45.4c-.6-.6-.6-1.5 0-2.1l14.9-15a1.5 1.5 0 1 1 2.1 2.2L37.4 44.3l13.8 13.8a1.5 1.5 0 0 1-1 2.6z"/></g></svg>';
var arrowRight = '<svg viewBox="0 0 90 90" width="90" height="90" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"><g><path d="M44.98.15c24.72 0 44.83 20.11 44.83 44.83s-20.1 44.83-44.83 44.83S.15 69.7.15 44.98 20.26.15 44.98.15zm0 86.62a41.84 41.84 0 0 0 41.8-41.79c0-23.04-18.76-41.79-41.8-41.79S3.2 21.94 3.2 44.98a41.84 41.84 0 0 0 41.8 41.79z"/><path d="M39.82 29.24c.39 0 .78.15 1.07.45l14.85 14.86c.6.6.6 1.56 0 2.15L40.9 61.57a1.52 1.52 0 1 1-2.15-2.16l13.78-13.78-13.78-13.8a1.52 1.52 0 0 1 1.08-2.59z"/></g></svg>';

var arrowLeftFat = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.4 74.1"><path fill="none" stroke-width="2" d="M121.3 29.9H28.8L47 11.6 37 1.4 1.3 37.1l35.6 35.6L47 62.5 28.8 44.2h92.5V30z"/></svg>';
var arrowRightFat = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.4 74.1"><path fill="none" stroke-width="2" d="M1 44.2h92.5L75.2 62.5l10.2 10.2L121 37 85.4 1.4 75.2 11.6l18.3 18.3H1z"/></svg>';

/**
 * If page object is inside document.ready it is not visible outside of it.
 * */
var page = {};
page.all = true; // Pass on every page
page.home = ($(document.body).hasClass('home'));
page.simpleList = ($(document.body).hasClass('page-template-simple-list'));
page.simple = ($(document.body).hasClass('page-template-simple'));
page.roomList = ($(document.body).hasClass('page-template-rooms'));
page.room = ($(document.body).hasClass('single-room'));
page.photoGallery = ($(document.body).hasClass('photo-gallery'));
page.loyalty = ($(document.body).hasClass('page-template-loyalty'));
page.location = ($(document.body).hasClass('page-template-location'));
page.contact = ($(document.body).hasClass('page-template-contact'));

$(document).ready(function ($) {
    var $body = $(document.body);

    // Internet Explorer IE11
    if ( navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1 ) {
        $body.addClass('trash-browser');
    }

    desktopMenu($body);

    // if (window.width > window.bpLarge) {
    //     desktopMenu($body);
    // }
    // else {
    //     mobileMenu();
    // }

    scroller({
        element: $body,
        classToggle: 'scrolled',
        breakpoint: window.width > window.bpLarge,
        tilt: 0,     // + 2% off the screen size,
        revert: true
    });

    scroller({
        element: $('#intro-section').find('.side-image'),
        classToggle: 'scrolled',
        breakpoint: window.width > window.bpLarge,
        tilt: 15,     // + 2% off the screen size,
        revert: false,
        page: page.home
    });

    scroller({
        element: $('#home-pages').find('a.home-page-item'),
        classToggle: 'scrolled',
        breakpoint: window.width > window.bpLarge,
        tilt: 5,     // + 2% off the screen size,
        revert: false,
        page: page.home
    });

    scroller({
        element: $('#listing-posts').find('.article'),
        classToggle: 'scrolled',
        breakpoint: window.width > window.bpLarge,
        tilt: 5,     // + 2% off the screen size,
        revert: false,
        page: page.simpleList
    });

    scroller({
        element: $('#room-items').find('.room-item'),
        classToggle: 'scrolled',
        breakpoint: window.width > window.bpLarge,
        tilt: 5,     // + 2% off the screen size,
        revert: false,
        page: page.roomList
    });

    (function() {
        if ( page.all ) {
            var $reviewsSlider = null;
            if ($reviewsSlider = $('#list-reviews')) {

                $reviewsSlider.slick({
                    arrows: false,
                    dots: true,
                    fade: false,
                    infinite: false,
                    autoplay: false,
                    // prevArrow: '<a class="slick-prev">' + arrowLeftFat + '</a>',
                    // nextArrow: '<a class="slick-next">' + arrowRightFat + '</a>',
                    responsive: [
                       {
                           breakpoint: 992,
                           settings: {
                               adaptiveHeight: true
                           }
                       }
                    ]
                });

                $reviewsSlider.find('.slick-prev,.slick-next').on('click', function (e) {
                    e.preventDefault();
                });
            }
        }
    })();

    (function() {
        if (page.all) {
            var $heroSlider = null;
            if ($heroSlider = $('#hero-inner')) {

                $('#hero-inner').slick({
                    arrows: true,
                    dots: false,
                    fade: false,
                    infinite: false,
                    autoplay: true,
                    prevArrow: '<a class="slick-prev">' + arrowLeftFat + '</a>',
                    nextArrow: '<a class="slick-next">' + arrowRightFat + '</a>',
                });

                $heroSlider.find('.slick-prev,.slick-next').on('click', function (e) {
                    e.preventDefault();
                });

                if ( page.home ) {

                }

            }
        }
    })();

    (function() {
        if (page.home) {

			if ( window.windowInnerWidth >= 992 ) {


                // $(document).off('click.bs.collapse.data-api');

                /**
                 * Collapse content from JS
                 *
                 * @1 On trigger (click, mouseover, etc)
                 * @2 We get from data-target the element that collapses
                 * @3 We apply the toggle event of collapse method
                 *
                 * We also have to add a data attribute with ID of parent on collapse item eq. data-parent="#items-list"
                 *
                 */
                $(".collapse-trigger").on("mouseover", function() {     // 1
                    var target = $(this).data('target');                // 2
                    $(target).collapse('toggle');                       // 3
                });



                //change image on different tab
                var $whyChooseImageList = $('#right-side-image-list');
				$("#whyChoose").on('show.bs.collapse', function (e) {
					$whyChooseImageList.children().removeClass('active');
					$whyChooseImageList.children('#' + $(e.target).attr('id') + 'Img').addClass('active');
				});

			} else {

				var $whyChoose = $('#whyChoose');

				$whyChoose.find('[data-toggle="collapse"]').click(function(e){
                    // Should prevent the collapsible and default anchor linking
                    // behavior for screen sizes equal or larger than 768px.
                    e.preventDefault();
                    e.stopPropagation();
                });

                $('#whyChoose').slick({
                    arrows: false,
                    dots: true,
                    fade: false,
                    infinite: false,
                    autoplay: false,
                    prevArrow: '<a class="slick-prev">' + arrowLeftFat + '</a>',
                    nextArrow: '<a class="slick-next">' + arrowRightFat + '</a>',
                    asNavFor: '#right-side-image-list',
                });

                $('#right-side-image-list').slick({
                    arrows: false,
                    dots: false,
                    fade: false,
                    infinite: false,
                    autoplay: false,
                    prevArrow: '<a class="slick-prev">' + arrowLeftFat + '</a>',
                    nextArrow: '<a class="slick-next">' + arrowRightFat + '</a>',
                    asNavFor: '#whyChoose',
                    responsive: [
                       {
                           breakpoint: 992,
                           settings: {
                               arrows: true
                           }
                       }
                    ]
                });

                var $roomsSectionImages = $('#rooms-section').find('.image-list');
                // $("#whyChoose").on('show.bs.collapse', function (e) {
                //     $whyChooseImageList.children().removeClass('active');
                //     $whyChooseImageList.children('#' + $(e.target).attr('id') + 'Img').addClass('active');
                // });

                $('#rooms-section [data-toggle="collapse"]').click(function(e){
                    // Should prevent the collapsible and default anchor linking
                    // behavior for screen sizes equal or larger than 768px.
                    e.preventDefault();
                    e.stopPropagation();
                });

                $('#rooms-section').find('.room-image-list').slick({
                    arrows: true,
                    dots: false,
                    fade: true,
                    infinite: false,
                    autoplay: false,
                    prevArrow: '<a class="slick-prev">' + arrowLeftFat + '</a>',
                    nextArrow: '<a class="slick-next">' + arrowRightFat + '</a>',
                });

                $('#home-page-items').slick({
                    arrows: false,
                    dots: true,
                    slide: 'a',
                    fade: false,
                    infinite: false,
                    autoplay: false,
                    adaptiveHeight: true,
                    prevArrow: '<a class="slick-prev">' + arrowLeftFat + '</a>',
                    nextArrow: '<a class="slick-next">' + arrowRightFat + '</a>',
                    responsive: [
                       {
                           breakpoint: 992,
                           settings: {
                               arrows: true
                           }
                       }
                    ]
                });
            }
        }
    })();

    (function() {
        if ( page.room ) {
            var $roomGallerylider = null;
            if ( $roomGallerylider = $('#inner-slider') ) {

                $roomGallerylider.slick({
                    arrows: true,
                    dots: true,
                    fade: false,
                    infinite: false,
                    autoplay: true,
                    // centerMode: true,
                    // variableWidth: true,
                    prevArrow: '<a class="slick-prev">' + arrowLeftFat + '</a>',
                    nextArrow: '<a class="slick-next">' + arrowRightFat + '</a>',
                });

                $roomGallerylider.find('.slick-prev,.slick-next').on('click', function (e) {
                    e.preventDefault();
                });
            }
        }
    })();

    (function() {
        if ( page.simple ) {
			var $pageGallerySlider = null;
			if ($pageGallerySlider = $('#page-gallery-inner')) {

				$pageGallerySlider.slick({
					arrows: true,
					dots: true,
					fade: false,
					infinite: true,
					autoplay: false,
                    speed: 1000,
					prevArrow: '<a class="slick-prev">' + arrowLeftFat + '</a>',
					nextArrow: '<a class="slick-next">' + arrowRightFat + '</a>',
				});

				$pageGallerySlider.find('.slick-prev,.slick-next').on('click', function (e) {
					e.preventDefault();
				});
			}
        }
    })();

    secondaryMenuHover();

    function secondaryMenuHover( options ) {
        options = $.extend(
            {
                trigger: '#secondary-navbar__inner .nav-link',
                matchedElement: '.menu-images .menu-image',
                activeElement: '',
                page: true,
                classToggle: 'active',
            },
            options
        );

        if ( page.all ) {

            $(options.trigger).on({

                'mouseover': function() {
                    var imageUrl = $(this).data('img');
					$( options.matchedElement + ' #applied-image').attr('src', imageUrl);

                    $( options.matchedElement ).addClass('active');
                    options.activeElement = $(this);
                },
                'mouseout': function() {
                    $(options.matchedElement).removeClass('active');
                }
            });

        }
    }

	$( window ).on( "orientationchange", function( event ) {
		pointAppear();
	});

	pointAppear();

	svgPlaceholder();

	function pointAppear() {

		if (page.location) {
			// $(window).on('resize', function() {
			//     location.reload();
			// });
			var $mapWrapper = $('#map-wrapper'),
				$points = $('#points'),
				$backgroundImages = $('#background-images'),
				$pointTooltips = $('#point-tooltips'),
				images = $backgroundImages.find('.background-image'),
				points = $points.find('.point'),
				pointTooltips = $pointTooltips.find('.point-tooltip');

			$points.find('.point').on('mouseenter touchstart', function() {

				var dataPin = $(this).data('pin');

				$.each(images, function(index, el) {
					if (index === dataPin) {
						$(el).addClass('active');
					}
				});

				$.each(points, function(index, el) {
					if (index === dataPin) {
						$(el).addClass('active');

						$mapWrapper.addClass('active-point');
					}
				});

				$.each(pointTooltips, function(index, el) {
					if (index === dataPin) {
						$(el).addClass('active');
					}
				});

				$(this).on('mouseleave touchend', function() {
					$mapWrapper.addClass('active-point').removeClass('active-point');
					$backgroundImages.find('.active').removeClass('active');
					$points.find('.active').removeClass('active');
					$pointTooltips.find('.active').removeClass('active');
				});
			});

			if (window.width >= window.bpIPadMin) {

				$.each(pointTooltips, function(index, el) {
					var left = $(el).offset().left,
						leftPercent = left / window.width * 100;

					$(el).css({
						'-webkit-transform' : 'translate(-'+leftPercent+'%, 2em)',
						'transform' : 'translate(-'+leftPercent+'%, 2em)',
					});
				});

			}
		}
	}

	function svgPlaceholder() {
		$('.svg-con').find('svg').each(function() {
			var viewBox = this.getAttribute('viewBox');

			if (typeof viewBox === 'string' || viewBox instanceof String) {
				var res = viewBox.split(" "),
					viewportWidth = res[2],
					viewportHeight = res[3],
					paddingTop = 100 / (viewportWidth / viewportHeight);

				$(this).prev().css('paddingTop', paddingTop + '%');
			}
		});
	}

    parallax({
        element: $('#right-side-image-list')
    });

    function parallax(options) {

        /* $(window).on('load', function() {*/
        options = $.extend(
            {
                element: $('.parallax'),
                page: true
            },
            options
        );

        // var $parent = $(options.element).parent;

        if ( options.page && options.element.length ) {
            var $parallaxElement 			= options.element;
            var $originalImg				= $parallaxElement.find('img');
            var windowHeight 				= $(window).height();
            var elementOffsetTop 			= $parallaxElement.offset().top;
            var elementHeight 				= $parallaxElement.find('img').height();

            ($parallaxElement).append();

            $(window).on('scroll', function (e) {

                /**
                 * If element's offset top, is visible on screen
                 */
                if (
                    (elementOffsetTop) < (parseInt(windowHeight) + window.pageYOffset) &&
                    (elementOffsetTop) + (elementHeight > window.pageYOffset)
                ) {

                    var eliminatePositionNumber =  Math.abs(elementOffsetTop - (window.pageYOffset + windowHeight));
                    var zoomFormula = 1 + ( eliminatePositionNumber / 200) / 10;

                    $parallaxElement.find('img').css({
                        position: 'relative',
                        transform:
                        'scale(' + zoomFormula + ')'
                    });
                }
            });

            // window.requestAnimationFrame(parallax);
        }
        /* }); */
    }

	/**
	 * Read More Toggler
	 */
	$.fn.readMoreToggler = function(selector) {
		var readMoreToggle = $(this),
			contactContent = $(this).parent().find(selector),
			readMoreToggleLink = readMoreToggle.find(".read-more-toggle-link"),
			entryContentHeight = contactContent.height(),
			entryContentMaxHeight = readMoreToggleLink.attr("data-max-height");

		if ( entryContentHeight > entryContentMaxHeight ) {
			contactContent.css("max-height", entryContentMaxHeight + "px" ).addClass("faded");
			readMoreToggle.removeClass("d-none");
			readMoreToggleLink.on("click", function(e) {
				e.preventDefault();
				$(this).toggleClass("toggled");
				if ($(this).hasClass("toggled")) {
					$(this).html($(this).attr("data-close-text"));
				}
				else {
					$(this).html($(this).attr("data-open-text"));
				}
				contactContent.toggleClass("toggled");
			});
		}
	};

	var readMoreToggle = $(".read-more-toggle");
	if (readMoreToggle.length > 0) {
		readMoreToggle.each(function () {
			if ( page.contact ) {
				$(this).readMoreToggler(".contact-inner");
			}
			else if ( page.room || page.simple || page.location || page.roomList) {
				$(this).readMoreToggler(".page-more-content");
			}

		});
	}
	if ( $('#fixed-message').length > 0 ) {
		var messageHeight = $('#fixed-message').outerHeight();
		$('.navbar-wrapper').css('margin-top',messageHeight);
		$('.menu__header').css('margin-top',messageHeight);
		if ($(window).width() <= 960) {
			$('#page-wrapper').css('margin-top',messageHeight);
		}
	}

	// below is for wave accessibility checker
	var label = document.createElement("label");
	label.innerHTML = '<span class="sr-only">Email:</span>';
	label.setAttribute("for", "mce-EMAIL");
	document.getElementById("mce-EMAIL").parentNode.insertBefore(label, document.getElementById("mce-EMAIL"));

	(function() {
		if (page.all) {
			var $heroSlider = null;
			if ($heroSlider = $('#social-feed')) {

				$('#social-feed').slick({
					arrows: true,
					dots: false,
					fade: false,
					infinite: true,
					autoplay: false,
					slidesToShow: 5,
					slidesToScroll: 1,
					centerMode: true,
					adaptiveHeight: true,
					prevArrow: '<a class="slick-prev">' + arrowLeftFat + '</a>',
					nextArrow: '<a class="slick-next">' + arrowRightFat + '</a>',
					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								centerMode: false,
							}
						}
					]
				});

				$heroSlider.find('.slick-prev,.slick-next').on('click', function (e) {
					e.preventDefault();
				});

			}
		}
	})();

});

function desktopMenu($body) {
    "use strict";

    var $wrapperNavbar = $('#secondary-menu'),
        $openBtn = $('#main-nav__button--toggle');

    var opened = $wrapperNavbar.hasClass('open');

    $openBtn.on('click', function() {

        $wrapperNavbar.toggleClass('open');
        $openBtn.toggleClass('open');
        $body.toggleClass('overflow-hidden');
        $body.toggleClass('menu-opened');

        // opened = $wrapperNavbar.hasClass('open');
        //
        // if (opened) {
        //     $wrapperNavbar.on('click', function (el) {
        //         console.log(el);
        //
        //         $wrapperNavbar.removeClass('open');
        //         $openBtn.removeClass('open');
        //         $body.removeClass('overflow-hidden menu-opened');
        //     });
        // }

    });
}

function mobileMenu() {
    var $menu = $("#secondary-menu");
    var logo = $('#main-header').find('.logo').parent().html();

    /**
     *It's not loaded on IE, under 1281 we dont' have menu on IE.
     */
    if (typeof $menu.mmenu !== "undefined") {

        $menu.mmenu({
            wrappers: [
                "wordpress"
            ],
            // extensions: [
            // 	"position-front"
            // ],
            // navbars     : [
            // 	{
            // 		height  : 3,
            // 		content : [
            // 			logo
            // 		]
            // 	}, true
            // ],
            header: true,
            className: {
                "selected": "active"
            },
            offCanvas: {
                position: "left"
            }
        });

        var api = $menu.data("mmenu");

        $(".main-nav__button--toggle").click(
            function (evnt) {
                evnt.preventDefault();
                api.open();
            }
        );

        //add social media
        //var mobileInformation = $('#nav-wrapper .infoWrapper').html();
        //$('#nav-wrapper .infoWrapper').remove();
        //$('#main-navbar .mm-listview').append('<li><div class="infoWrapper">'+mobileInformation+'</div></li>');

        //remove bootstrap classes
        $menu.removeClass('nav navbar-nav');
        $('#main-navbar ul').removeClass('dropdown-menu animated fadeInDown');
        $('#main-navbar li').removeClass('dropdown');
        $('#main-navbar li a').removeClass('dropdown-toggle').removeAttr("data-toggle data-target");

        // show logo instead of menu title text
        $('#main-navbar .mm-navbar__title').html(logo);

    }
}


function scroller(options) {
    options = $.extend(
        {
            element: '.animate-this',
            page: true,
            tilt: 5,
            classToggle: 'revealed',
            breakpoint: true,
            revert: false
        },
        options
    );
    var windowHeight = window.innerHeight;
    var tiltHeight = windowHeight / 100 * options.tilt;

    // options.tilt = (windowHeight) / options.tilt;

    $(window).on('load', function() {
        // if this page is true and if this breakpoint is true
        if (options.page && options.breakpoint) {

            // if exists at least 1 item
            if ($(options.element).length) {

                $(options.element).each(function () {

                    var $thisItem = $(this);

                    var flag = true;

                    // element on scroll
                    $(document).on("scroll", function () {

                        // If flag is false do not removed classes
                        if (flag) {

                            var scroll = getCurrentScroll();

                            if ($thisItem.offset().top + tiltHeight < scroll + windowHeight) {

                                if ($thisItem.hasClass(options.classToggle)) {
                                    // do not do anything
                                } else {
                                    // alert($thisItem.position().top);
                                    $thisItem.addClass(options.classToggle);

                                    if (!options.revert) {
                                        flag = options.revert;
                                    }
                                }

                            } else {

                                if ($thisItem.hasClass(options.classToggle)) {

                                    $thisItem.removeClass(options.classToggle);

                                }
                            }
                        }
                    });

                    /**
                     * @fixme do not repeat your self! It's the same as the above code
                     */
                    if (flag) {

                        var scroll = getCurrentScroll();

                        if ($thisItem.position().top + tiltHeight < scroll) {

                            if ($thisItem.hasClass(options.classToggle)) {
                                // do not do anything
                            } else {
                                $thisItem.addClass(options.classToggle);

                                if (!options.revert) {
                                    flag = options.revert;
                                }
                            }

                        } else {

                            if ($thisItem.hasClass(options.classToggle)) {

                                $thisItem.removeClass(options.classToggle);

                            }
                        }
                    }
                });
            }

        }
    });
}

function getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
}


function resizeImages() {
    if(window.innerWidth < window.innerHeight) {
        $('.first-slideshow').addClass('fsh-fix').removeClass('fsw-fix');
    } else {
        $('.first-slideshow').addClass('fsw-fix').removeClass('fsh-fix');
    }

    $( ".home-accommodation-cell" ).each( function(e){
        var haWidth = $(this).width();
        var haHeight = $(this).height();

        if(haWidth < haHeight) {
            $(this).addClass('hah-fix').removeClass('haw-fix');
        } else {
            $(this).addClass('haw-fix').removeClass('hah-fix');
        }
    });
}

function fixedFooter() {
    if ( $(window).height() > 750 ) {
        var instagramFeed = $("#sbi_images");
        var wrapperFooter = $("#wrapper-footer");
        var page = $("#page");
        if ( instagramFeed.length > 0 ) {
            instagramFeed.imagesLoaded(function () {
                wrapperFooter.addClass('fixed-bottom');
                page.css( "margin-bottom", wrapperFooter.height() );
            });
        }
    }
}

jQuery(document).ready(function ($) {
    "use strict";


    // fixedFooter();

    function homePromosSlider() {

        var $wrapHomePromos = $('#wrap-home-promos');

        if (window.innerWidth >= 992) {
            if ($wrapHomePromos.hasClass('slick-slider')) {
                $wrapHomePromos.slick('unslick');
                $wrapHomePromos.find('.wrap-home-promo').css({
                    'opacity': 1,
                    'z-index': 0
                });
            } else {
                $wrapHomePromos.homePromos();
            }
        } else {
            // Features Slideshow
            if ($wrapHomePromos.length > 0) {
                $wrapHomePromos.slick({
                    mobileFirst: true,
                    autoplay: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    //centerMode: true,
                    variableWidth: false,
                    arrows: true,
                    dots: false,
                    fade: true,
                    //responsive: [
                    //    {
                    //        breakpoint: 992,
                    //        settings: 'unslick'
                    //    }
                    //]
                });
            }
        }
    }

    // Promos Slideshow (Inner Pages/CPTs)
    var $promosSlideshow = $('*[data-promos-slideshow]');
    if ($promosSlideshow.length > 0) {
        $promosSlideshow.slick({
            arrows: true,
            // centerMode: true,
            // centerPadding: '20px',
            // centerMode: true,
            // centerPadding: '0',
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    var $roomUpgradeSlideshow = $('*[data-room-upgrade-slideshow]');
    if ($roomUpgradeSlideshow.length > 0) {
        $roomUpgradeSlideshow.flickity({
            contain: true,
            autoPlay: false,
            cellSelector: '.slideshow-cell',
            accessibility: true,
            prevNextButtons: true,
            // pageDots: $roomUpgradeSlideshow.find('.slideshow-cell').length > 1,
            pageDots: false,
            setGallerySize: false,
            imagesLoaded: true,
            lazyLoad: true,
            draggable: '>1',
            wrapAround: true
        });
    }


    // Bootstrap Tabs Slideshow
    var $tabSlideshow = $('*[data-tab-slideshow]');
    if ($tabSlideshow.length > 0) {
        $tabSlideshow.each(function(obj) {
            var el = $(this);

            el.flickity({
                contain: true,
                cellSelector: '.slideshow-cell',
                accessibility: true,
                prevNextButtons: el.find('.slideshow-cell').length > 1,
                pageDots: el.find('.slideshow-cell').length > 1,
                // setGallerySize: false,
                imagesLoaded: true,
                lazyLoad: true,
                wrapAround: true
            });

        });

        // element flickity resize on tab switch
        $('.nav-tabs, .nav-pills').on( 'shown.bs.tab', 'a', function( event ) {
            // get tab pane
            var activeTab = event.target.getAttribute('href');

            // element resize on tab pane
            $(activeTab).flickity('resize');

        });
    }

    // // Accommodation Filtering
    // var $filters = $('.filters');
    // if ($filters.length > 0) {
    //     var $listingWrapper = $('.listing-wrapper').imagesLoaded( function() {
    //         $listingWrapper.isotope({
    //             itemSelector: 'article'
    //         });
    //         $filters.on('click', 'a', function() {
    //             var filterValue = $(this).attr('data-filter');
    //             $listingWrapper.isotope({
    //                 filter: filterValue
    //             });
    //         });
    //     });
    // }
    //



    masonry({
        page: page.home
    });

    function masonry(options) {

        options = $.extend(
            {
                element: $('#home-page-items'),
                page: false,
                breakpoint: window.innerWidth >= window.bsLGB
            },
            options
        );

        if ( page && options.breakpoint ) {

            // Masonry Gallery
            if ( options.element ) {

                options.element.imagesLoaded(function () {
                    options.element.isotope({
                        itemSelector: '.home-page-item',
                        percentPosition: true,
                        masonry: {
                            percentPosition: true,
                            horizontalOrder: true
                        }
                    });
                });
            }
        }
    }

    // // Scroll Top
    var $scrollTop = $('#scroll-top');
    if ($scrollTop.length > 0) {

        var tilt = 200;

        $(window).on({
            'scroll': function () {

                if ( getCurrentScroll() > tilt ) {
                    $scrollTop.addClass('visible');
                } else {
                    $scrollTop.removeClass('visible');
                }

            }
        });

        $scrollTop.on('click', function(e) {
            e.preventDefault();

            $("html, body").animate({
                scrollTop: $('body').offset().top
            }, 500);
        });
    }

	// Masonry Gallery
	var $gallery = $('#masonry-gallery');
	if ($gallery.length > 0) {
		$gallery.imagesLoaded( function() {
			// init Isotope after all images have loaded
			$gallery.isotope({
				itemSelector: '.gallery-item',
				percentPosition: true,

				// layout mode options
				masonry: {
					gutter: '.gallery-gutter-sizer',
					columnWidth: '.gallery-item-sizer'
				}

			});
		});

		// filter items on button click
		$('#masonry-gallery-filters li').on('click', 'a', function() {

            $('.gallery-item').preloader({
                loader: '/wp-content/themes/athensikon/img/loader-6.svg',
                fadeIn: 300,
                delay : 100
            });

			$gallery.isotope({
				filter: $(this).attr('data-filter')
			});
		});

		// Lightbox
		$gallery.photoswipeLightbox($gallery.data('photoswipe-options'));
	}
});

$(window).on('resize', function() {
    sideImage();

});

$(window).on('load', function () {

    // Equal Heights
    if ($('*[data-equal-heights]').length > 0) {
        $('*[data-equal-heights]').equalHeights();
    }

    sideImage({
        page: page.home
    });

	if (page.home) {
		var $homeGallerySlider = $('#home-gallery-inner');
		if ($homeGallerySlider) {

			$homeGallerySlider.slick({
				arrows: true,
				dots: false,
				fade: false,
				infinite: true,
				autoplay: false,
				speed: 1000,
				prevArrow: '<a class="slick-prev">' + arrowLeftFat + '</a>',
				nextArrow: '<a class="slick-next">' + arrowRightFat + '</a>',
				responsive: [
					{
						breakpoint: 992,
						settings: {
							dots: true,
							adaptiveHeight: true,
						}
					},
				]
			});

			$homeGallerySlider.find('.slick-prev,.slick-next').on('click', function (e) {
				e.preventDefault();
			});
		}
	}

});

function sideImage(options) {
    options = $.extend(
        {
            element: $('.bookwize-book-button'),
            page: false,
            breakpoint: window.innerWidth >= window.bsLGB
        },
        options
    );

    if ( options.page && options.element ) {
        var $sideImage = $('#side-image');

        if ( $sideImage ) {

            if ( options.element.length ) {

                var offsetLeft = options.element.offset().left;
                var newWidth = $(window).width() - offsetLeft;

                $sideImage.css('maxWidth', newWidth);

            }
        }

    }
}

$(function($) {

    "use strict";

    $(window).scroll(function() {

    });

    $(window).resize(function() {
        // resizeImages();
        // fixedFooter();
    });

});

(function($) {

    "use strict";

    // Homepage Promos
    $.fn.homePromos = function(options) {
        var el = $(this);
        var settings = $.extend({
            'promo'     : '.wrap-home-promo',
            'promoImg'  : '.home-promo-cell img',
            'btn'       : '.slide-btn'
        }, options);

        var func = {
            // Plugin Initialize Function
            init: function() {
                var self = this;

                self.firstLoad();
                self.btnClick();
            },
            // Change First Image
            firstLoad: function() {
                var images = el.find(settings.promoImg);

                for (var i = 0; i < images.length; i++) {
                    func.imgSize($(images[i]), i);
                }
            },
            // Change Image Source
            imgSize: function(img, i) {
                // 0 = Large Size
                // 1 = Small Size
                var sizes = img.data('sizes').split(',');
                var src = img.attr('src');

                if ( i === 0 && src !== sizes[0] ) {
                    img.attr('src', sizes[0]);
                } else if (i !== 0 && src !== sizes[1]) {
                    img.attr('src', sizes[1]);
                }
            },
            // Button Click
            btnClick: function() {
                $(settings.btn).on('click', function(e) {
                    var btn = $(this);
                    var action = btn.hasClass('slide-prev') ? 'prev' : 'next';

                    func.promoChange(action);
                });
            },
            // Change Promo
            promoChange: function (action) {
                var promos = el.find(settings.promo);
                var oldPromos = promos.clone();
                var pos = -1;

                for (var i = 0; i < promos.length; i++) {
                    if (action === 'prev') {
                        // Custom Order
                        switch (i) {
                            case 0:
                                pos = 2;
                                break;
                            case 1:
                                pos = 0;
                                break;
                            case 2:
                                pos = 4;
                                break;
                            case 3:
                                pos = 1;
                                break;
                            case 4:
                                pos = promos.length - 1;
                                break;
                            case 5:
                                pos = 3;
                                break;
                            default:
                                pos = i - 1;
                        }
                        $(promos[i]).html($(oldPromos[pos]).html());
                        /*
                        // Default Order
                        if (i === 0) {
                            $(promos[i]).html($(oldPromos[promos.length - 1]).html());
                        } else {
                            $(promos[i]).html($(oldPromos[i-1]).html());
                        }
                        */
                    } else {
                        // Custom Order
                        switch (i) {
                            case 0:
                                pos = 1;
                                break;
                            case 1:
                                pos = 3;
                                break;
                            case 2:
                                pos = 0;
                                break;
                            case 3:
                                pos = 5;
                                break;
                            case 4:
                                pos = 2;
                                break;
                            case promos.length - 1:
                                pos = 4;
                                break;
                            default:
                                pos = i + 1;
                        }
                        $(promos[i]).html($(oldPromos[pos]).html());

                        /*
                        // Default Order
                        if (i === promos.length - 1) {
                            $(promos[i]).html($(oldPromos[0]).html());
                        } else {
                            $(promos[i]).html($(oldPromos[i+1]).html());
                        }
                        */
                    }

                    func.imgSize($(promos[i]).find(settings.promoImg), i);
                }
            }
        };

        func.init();
    };

    // Google Map Function
    $.fn.googleMap = function(options) {
        var el = $(this);

        var settings = $.extend({
            'lat'           : '37.979561',
            'lng'           : '23.728487',
            'zoom'          : 13,
            'styles'        : '',
            'locations'     : [{
                lat             : -33.890542,
                lng             : 151.274856,
                address         : '',
                image_src       : '',
                image_alt       : '',
                info_title      : '',
                info_text       : '',
                info_btn        : '',
                info_btn_url    : '',
                info_btn_target : ''
            }]
        }, options);

        var markers = [];
        var bounds = new google.maps.LatLngBounds();
        var map = new google.maps.Map(el[0], {
            zoom: settings.zoom,
            zoomControl: true,
            scaleControl: false,
            scrollwheel: false,
            styles: settings.styles ? settings.styles : '',
            streetViewControl: false,
            disableDoubleClickZoom: true,
            mapTypeControl: false,
            fullscreenControl: false
        });

        $.each(settings.locations, function (i, attr) {

            var locLatLng = new google.maps.LatLng(attr.lat, attr.lng);

            var infoButtonString = "";

            if (attr.info_btn_url) {
                infoButtonString = '<p><a href="'+attr.info_btn_url+'" target="'+attr.info_btn_target+'">'+attr.info_btn+'</a></p>';
            }

            var contentString =
                '<div class="map-infowindow">'+
                    '<div class="side-gmap">'+
                        '<img src="'+attr.image_src+'" alt="'+attr.image_alt+'" />'+
                    '</div>'+
                    '<div class="main-gmap">'+
                        '<h3 class="text-dark">'+attr.info_title+'</h3>'+
                        '<div class="text-dark">'+attr.info_text+
                            infoButtonString+
                        '</div>'+
                    '</div>'+
                '</div>';

            var markerInfowindow = new google.maps.InfoWindow({
                content: contentString
            });

            var marker = new google.maps.Marker({
                position: locLatLng,
                map: map,
                infowindow: markerInfowindow
            });

            markers.push(marker);

            marker.addListener('click', function() {
                hideAllInfoWindows(map);
                this.infowindow.open(map, this);
                map.setCenter(this.getPosition());
                map.panTo(this.getPosition());
            });

            map.panTo(marker.getPosition());
            bounds.extend(locLatLng);

        });

        if (Object.keys(settings.locations).length > 1) {

            map.fitBounds(bounds);

        }
        else if (Object.keys(settings.locations).length === 1) {

            map.setZoom(settings.zoom);

        }

        function hideAllInfoWindows(map) {

            markers.forEach(function(marker) {

                marker.infowindow.close(map, marker);

            });

        }

    };

    // // Photoswipe Lightbox
    $.fn.photoswipeLightbox = function(options) {
        var el = $(this);

        var settings = $.extend({
			bgOpacity: 0.7,
            closeOnScroll: true,
            escKey: true,
            arrowKeys: true,
            loop: true,
            history: true,
            focus: true,
            modal: true,
            showHideOpacity: true,
            closeEl: true,
            captionEl: true,
            fullscreenEl: true,
            zoomEl: true,
            shareEl: true,
            counterEl: true,
            arrowEl: true,
            preloaderEl: true,
        }, options);

        el.each( function() {
            var $pic     = $(this),
                getItems = function() {
                    var items = [];
                    $pic.find('a').each(function() {

                        var $href   = $(this).data('src'),
                            $w   = $(this).data('width'),
                            $h  = $(this).data('height'),
                            $msrc  = $(this).find('img').attr('src'),
                            $title  = $(this).data('title'),
                            $pid  = $(this).data('slug');

                        var item = {
                            src : $href,
                            w   : $w,
                            h   : $h,
                            msrc   : $msrc,
                            title   : $title,
                            pid   : $pid
                        };

                        items.push(item);
                    });
                    return items;
                };

            var items = getItems();

            var $pswp = $('.pswp')[0];
            $pic.on('click', 'a', function(event) {
                event.preventDefault();

                var $index = $(this).data('index');
                var options = {
                    index: $index,
                    bgOpacity: settings.bgOpacity,
                    spacing: 0.12,
                    allowPanToNext: true,
                    pinchToClose: true,
                    closeOnScroll: settings.closeOnScroll,
                    closeOnVerticalDrag: true,
                    escKey: settings.escKey,
                    arrowKeys: settings.arrowKeys,
                    history: settings.history,
                    mouseUsed: false,
                    loop: settings.loop,
                    focus: settings.focus,
                    modal: settings.modal,
                    showHideOpacity: settings.showHideOpacity,
                    showAnimationDuration: 333,
                    hideAnimationDuration: 333,
                    closeEl: settings.closeEl,
                    captionEl: settings.captionEl,
                    fullscreenEl: settings.fullscreenEl,
                    zoomEl:  settings.zoomEl,
                    shareEl:  settings.shareEl,
                    counterEl: settings.counterEl,
                    arrowEl: settings.arrowEl,
                    preloaderEl:  settings.preloaderEl,
                };

                // Initialize PhotoSwipe
                var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
                lightBox.init();
            });
        });
    };

    // Date & Time
    $.fn.dateTime = function(options) {
        var el = $(this);

        var settings = $.extend({
            'day'           : '.map-day',
            'time'          : '.map-time',
            'dayNames'      : new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"),
            'monthNames'    : new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December")
        }, options);

        var func = {
            // Plugin Initialize Function
            init: function() {
                var self = this;

                self.getDate();
                setInterval(self.getDate, 500);
            },
            // Plugin Create Time
            getDate: function() {
                var today = new Date();
                var dayName = settings.dayNames[today.getDay()];
                var day = today.getDate();
                var month = settings.monthNames[today.getMonth()];
                var year = today.getFullYear();
                var hours = today.getHours();
                var mins = today.getMinutes();

                hours = func.checkTime(hours);
                mins = func.checkTime(mins);

                $(settings.day).html(dayName + " " + day + " " + month + " " + year);
                $(settings.time).html(hours + ":" + mins);
            },
            // Plugin Check Time
            checkTime: function(i) {
                if (i < 10) {
                    i = "0"+i;
                }

                return i;
            }
        };

        func.init();
    };

    // Homepage Video
    $.fn.video = function(options) {
        var el = $(this);
        var settings = $.extend({
            'video_id'  : '',
            'mute'      : true,
            'loop'      : false,
            'autoplay'  : false
        }, options);

        var id = settings.video_id;
        var autoplay = settings.autoplay ? 1 : 0;
        var mute = settings.mute ? 1 : 0;
        var repeat = settings.loop ? 1 : 0;
        if(id.length > 0 ) {
            el.YTPlayer({
                fitToBackground: false,
                videoId: id,
                mute: mute,
                height: '700',
                pauseOnScroll: false,
                playerVars: {
                    autoplay: autoplay,
                    rel: 0,
                    loop: repeat,
                    origin: window.location.origin
                }
            });
            el.css({
                'position' : 'absolute',
                'top' : '50%',
                'left' : '50%',
                'transform' : 'translate(-50%, -50%)'
            });
        }

        $('.nav-link').on('shown.bs.tab', function(e) {
            var player = el.data('ytPlayer').player;

            //player.pauseVideo();
            player.stopVideo();
            // if ($('.slideshow.home-slider').length > 0) {
            //     $('.slideshow.home-slider').show().flickity('resize');
            // }
        });
    };

    // Equal Heights Function
    $.fn.equalHeights = function(options) {
        var els = $(this);
        var settings = $.extend({
            'elMaxHeight' : 0
        }, options);

        var func = {
            // Plugin Initialize Function
            init: function() {
                var self = this;

                self.equalHeight();
                self.resize(self);
            },
            // Plugin Resize Function
            resize: function(self) {
                $(window).resize(function () {
                    self.equalHeight();
                });
            },
            // Plugin Equal Heights
            equalHeight: function() {
                els.each(function() {
                    var el = $(this);
                    var elHeight = el.innerHeight();

                    settings.elMaxHeight = elHeight > settings.elMaxHeight ? elHeight : settings.elMaxHeight;
                });

                return els.css('height', settings.elMaxHeight);
            }
        };

        func.init();
    };

    // Main Navigation Function
    // $.fn.mainNavMenu = function(options) {
    //     var el = $(this);
    //     var settings = $.extend({
    //         'mainMenu'  : '.main-menu-row',
    //         'menuBtn'   : '.hamburger',
    //         'menuNav'   : '.main-nav',
    //         'subMenuBtn': '.menu-item-has-children > a',
    //         'subMenuNav': '.sub-menu',
    //         'scrollTop' : '.scroll-top'
    //     }, options);
    //
    //     var func = {
    //         // Plugin Initialize Function
    //         init: function() {
    //             var self = this;
    //
    //             self.openMenu();
    //             self.openSubMenu();
    //             self.stylesMenu();
    //
    //             self.resize(self);
    //             self.scroll(self);
    //
    //         },
    //         // Plugin Resize Function
    //         resize: function(self) {
    //             $(window).resize(function () {
    //                 self.stylesMenu();
    //             });
    //         },
    //         // Plugin Scroll Function
    //         scroll: function(self) {
    //             $(window).scroll(function() {
    //                 self.stylesMenu();
    //             });
    //         },
    //         // Plugin Open Menu Item Function
    //         openMenu: function() {
    //             el.find(settings.menuBtn).on('click', function (e) {
    //                 e.preventDefault();
    //                 el.find(settings.menuBtn).toggleClass('open-nav');
    //                 el.find(settings.menuNav).toggleClass('open-nav');
    //                 $('html').toggleClass('scrollbug');
    //             });
    //         },
    //         // Plugin Open Submenu Item Function
    //         openSubMenu: function() {
    //             el.find(settings.subMenuBtn).on('click', function (e) {
    //                 e.preventDefault();
    //
    //                 var btn = $(this);
    //                 var isActive;
    //
    //                 if (btn.hasClass('open-nav')) {
    //                     isActive = true;
    //                 }
    //
    //                 el.find(settings.subMenuBtn).removeClass('open-nav');
    //                 el.find(settings.subMenuNav).removeClass('open-nav');
    //
    //                 if (isActive !== true) {
    //                     btn.addClass('open-nav');
    //                     btn.siblings(settings.subMenuNav).addClass('open-nav');
    //                 }
    //                 //btn.toggleClass('open-nav');
    //                 //btn.siblings(settings.subMenuNav).toggleClass('open-nav');
    //             });
    //         },
    //         // Plugin Styles Modification Function
    //         stylesMenu: function() {
    //             var windowTop = ($(window).scrollTop());
    //             var contentTop = $('section').eq(1).offset().top - $(settings.mainMenu).height();
    //             ;
    //             if (windowTop >= contentTop) {
    //                 el.addClass('header-solid');
    //
    //                 if ($('.scroll-top').length > 0)
    //                     $('.scroll-top').addClass('show-scroll');
    //
    //             } else {
    //                 el.removeClass('header-solid');
    //
    //                 if ($('.scroll-top').length > 0)
    //                     $('.scroll-top').removeClass('show-scroll');
    //             }
    //         }
    //     };
    //
    //     func.init();
    // };

    // Accommodation Listing Function
    // $.fn.accommodationListing = function(options) {
    //     var el = $(this);
    //     var settings = $.extend({
    //         'btns'   : '.menu-link' ,
    //         'items'  : '.accommodation-item'
    //     }, options);
    //
    //     var func = {
    //         // Plugin Initialize Function
    //         init: function() {
    //             var self = this;
    //
    //             self.pageLoad();
    //             self.menuClick();
    //         },
    //         // Plugin Page Load Function
    //         pageLoad: function(){
    //             if(window.location.hash) {
    //                 var hash = window.location.hash.slice(1);
    //                 var btns = el.find(settings.btns);
    //                 var items = $(settings.items);
    //
    //                 btns.parent().removeClass('active show');
    //
    //                 btns.each(function() {
    //                     var btn = $(this);
    //                     var target = btn.attr('href');
    //                     var itemCat = target.slice(1);
    //
    //                     if ( itemCat === hash ) {
    //                         btn.parent().addClass('active show');
    //                     }
    //                 });
    //
    //                 items.each(function() {
    //                     var elItem = $(this);
    //                     var itemCat = elItem.data('category');
    //
    //                     if ( itemCat !== hash ) {
    //                         elItem.hide();
    //                     }
    //                 });
    //             }
    //         },
    //         // Plugin Menu Item Click Function
    //         menuClick: function() {
    //             var btns = el.find(settings.btns);
    //             var items = $(settings.items);
    //
    //             btns.each(function() {
    //                 var btn = $(this);
    //
    //                 btn.on('click', function(e) {
    //                     e.preventDefault();
    //
    //                     var elBtn = $(this);
    //                     var target = elBtn.attr('href');
    //
    //                     btns.removeClass('active show');
    //                     //items.fadeOut('slow', 'swing');
    //                     items.hide();
    //                     elBtn.addClass('active show');
    //
    //                     if (target.charAt(0) === '.') {
    //                         var className = target.slice(1);
    //
    //                         items.each(function() {
    //                             var elItem = $(this);
    //                             var itemCat = elItem.data('category');
    //
    //                             if ( itemCat === className ) {
    //                                 elItem.fadeIn('slow', 'swing');
    //                             }
    //                         });
    //                     } else {
    //                         items.fadeIn('slow', 'swing');
    //                     }
    //                 });
    //             });
    //         }
    //     };
    //
    //     func.init();
    // };

    // Slick Navigation Function
    $.fn.slickNavigation = function(options) {
        var els = $(this);
        var settings = $.extend({
            'slider'        : '.wrap-features',
            'arrow'         : '.slick-arrow',
            'slide'         : '.slick-slide',
            'currentSlide'  : '.slick-current',
            'menu'          : '.features-menu'
        }, options);

        var func = {
            // Plugin Initialize Function
            init: function () {
                var self = this;

                // Slider Initialize Function
                $(settings.slider).on('init', function(event, slick){
                    self.menuClick();

                    $(settings.arrow).add(settings.slide).on('click', function() {
                        self.sliderClick();
                    });
                });
            },
            // Plugin Menu Click Item Function
            menuClick: function() {
                els.on('click', function(e) {
                    e.preventDefault();

                    var el = $(this);
                    var index = el.data('slide');

                    els.removeClass('active');
                    el.addClass('active');
                    $(settings.slider).slick('slickGoTo', index);
                });

            },
            // Plugin Slider Click Item Function
            sliderClick: function() {
                var currentSlide = $(settings.currentSlide).data('slick-index');

                els.removeClass('active');
                els.parent().removeClass('active');
                els.each(function(index) {
                    var menuEl = $(this);
                    var menuElIndex = menuEl.data('slide');

                    if (menuElIndex === currentSlide) {
                        menuEl.addClass('active');
                        menuEl.parent().addClass('active');
                    }
                });
            }
        };

        func.init();
    };

    // Bootstrap Tabs Extension Function
    // $.fn.tabsSelection = function(options) {
    //     var el = $(this);
    //     var settings = $.extend({
    //         'menuLink'          : '.nav-link',
    //         'slideshow'         : '*[data-tab-slideshow]',
    //         'wideContent'       : '*[data-img-tabs]',
    //         'wideContainer'     : '.wrap-wide-content',
    //         'wideContentCell'   : '.inner-content-cell'
    //     }, options);
    //
    //     var func = {
    //         // Plugin Initialize Function
    //         init: function () {
    //             var self = this;
    //
    //             self.menuClick();
    //         },
    //         // Plugin Menu Item Click Function
    //         menuClick: function() {
    //             $(settings.menuLink).on('shown.bs.tab', function(e) {
    //                 var elMenu = $(this);
    //                 var target = elMenu.attr('href');
    //
    //                 // Re-initialize Flickity Slider
    //                 if ($(settings.slideshow).length > 0)
    //                     $(target + ' ' + settings.slideshow).flickity('resize');
    //
    //                 // Change Wide Content Image
    //                 if ($(settings.wideContent).length > 0) {
    //                     var container = elMenu.parents(settings.wideContainer);
    //                     var imgClass = '.'+target.slice(1);
    //                     container.find(settings.wideContentCell).removeClass('active');
    //                     container.find(imgClass).addClass('active');
    //                 }
    //             });
    //         }
    //     };
    //
    //     func.init();
    // };



})(jQuery);
